import React from 'react';
import classes from './signedDocument.module.css';

const SignedDocuments = (props) => {
    const handleKidChange = (index, value) => {
        const updatedKids = [...props.kids];

        if (value === "" || value === null) {
            // Remove the value if it's an empty string or null
            updatedKids.splice(index, 1);
        } else {
            // Otherwise, update the specific index
            updatedKids[index] = value;
        }

        // Filter out any empty values and update the state
        props.setKids(updatedKids.filter((kid) => kid));
    };

    const translations = {
        declaration: {
            en: 'Declaration By The Guardian',
            ar: 'إقرار من الوصي'
        },
        toSigned: {
            en: 'To be signed by the Guardians',
            ar: 'يجب التوقيع من قبل الأوصياء'
        },
        enterName: {
            en: 'Enter your name',
            ar: 'أدخل اسمك'
        },
        address: {
            en: 'of address',
            ar: 'العنوان'
        },
        enterAddress: {
            en: 'Enter your address',
            ar: 'أدخل عنوانك'
        },
        email: {
            en: 'and email',
            ar: 'والبريد الإلكتروني'
        },
        enterEmail: {
            en: 'Enter your email',
            ar: 'أدخل بريدك الإلكتروني'
        },
        responsibility: {
            en: 'being a person having parental responsibility for',
            ar: 'بصفتي الشخص المسؤول عن'
        },
        firstKid: {
            en: 'First kid name',
            ar: 'اسم الطفل الأول'
        },
        and: {
            en: 'and',
            ar: 'و'
        },
        secondKid: {
            en: 'Second kid name',
            ar: 'اسم الطفل الثاني'
        },
        signBelow: {
            en: 'Please sign in the field below',
            ar: 'يرجى التوقيع في الحقل أدناه'
        },
        signature: {
            en: 'Signature',
            ar: 'التوقيع'
        }
    };

    return (
        <div className={classes.declarationContainer}>
            <div className={classes.textDeclarationTitle}>
                {parseInt(localStorage.getItem('language')) === 1 ? translations.declaration.en : translations.declaration.ar}
            </div>
            <div className={classes.signatureSection}>
                <span>{parseInt(localStorage.getItem('language')) === 1 ? translations.toSigned.en : translations.toSigned.ar}</span>
                <div className={classes.redDot}>*</div>
            </div>
            <div className={classes.iText}>
                I,
                <div className={classes.inputLine}>
                    <input placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.enterName.en : translations.enterName.ar} onChange={(e) => props.setName(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.inputGroup}>
                <span>{parseInt(localStorage.getItem('language')) === 1 ? translations.address.en : translations.address.ar}</span>
                <div className={classes.inputLine}>
                    <input placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.enterAddress.en : translations.enterAddress.ar} onChange={(e) => props.setAddress(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.inputGroup}>
                <span>{parseInt(localStorage.getItem('language')) === 1 ? translations.email.en : translations.email.ar}</span>
                <div className={classes.inputLine}>
                    <input type='email' placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.enterEmail.en : translations.enterEmail.ar} onChange={(e) => props.setEmail(e.target.value)} />
                    <div className={classes.redDot}>*</div>
                </div>
            </div>
            <div className={classes.responsibilityText}>
                {parseInt(localStorage.getItem('language')) === 1 ? translations.responsibility.en : translations.responsibility.ar}
            </div>
            <div className={classes.inputLine}>
                <input
                    placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.firstKid.en : translations.firstKid.ar}
                    value={props.kids[0] || ""} // Bind the first kid's value
                    onChange={(e) => handleKidChange(0, e.target.value)} // Update first kid
                />
                <div className={classes.redDot}>*</div>
            </div>
            <div className={classes.andText}>{parseInt(localStorage.getItem('language')) === 1 ? translations.and.en : translations.and.ar}</div>
            <div className={classes.inputLine}>
                <input
                    placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.secondKid.en : translations.secondKid.ar}
                    value={props.kids[1] || ""} // Bind the second kid's value
                    onChange={(e) => handleKidChange(1, e.target.value)} // Update second kid
                />
            </div>
            <div className={classes.certifyText}>
                , and certify that the above details are correct and that in consideration of 6 Yard's acceptance of
                the Entrant's entry into the 6 Yard, the receipt and sufficiency of which consideration is acknowledged,
                hereby release and forever discharge 6 Yard, its owners, directors, officers, employees, agents, assigns,
                legal representatives, and successors from all manner of actions, causes of action, debts, accounts, bonds,
                contracts, claims, and demands for or by reason of any injury to the Entrant which has been or may be
                sustained as a consequence of an incident occurring at the 6 Yard or arising from the Entrant's
                participation in the 6 Yard.
            </div>
            <div className={classes.waiverText}>
                I hereby further declare that the terms of this waiver are fully understood; that the amount or type of
                consideration stated consideration is accepted voluntarily for the purpose of making a full and final
                compromise and settlement of all claims for injuries, losses, and damages which may result from the
                aforementioned incident or the Entrant's participation in the 6 Yard.
            </div>
            <div className={classes.signBelowText}>{parseInt(localStorage.getItem('language')) === 1 ? translations.signBelow.en : translations.signBelow.ar}</div>
            <div className={classes.inputSignature}>
                <input className={classes.signatureName} placeholder={parseInt(localStorage.getItem('language')) === 1 ? translations.signature.en : translations.signature.ar} onChange={(e) => props.setSignature(e.target.value)} />
                <div className={classes.redDot}>*</div>
            </div>
        </div>
    );
}

export default SignedDocuments;